import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { type Formula } from './formula';
import { selectFormulaFunctions } from './formulas.selectors';

/** Synchronous access to the formula-function catalogue, for the callers that cannot await it. */
@Injectable({ providedIn: 'root' })
export class FormulasFacade {
  private readonly store = inject(Store);

  private readonly formulas$ = this.store.select(selectFormulaFunctions);

  formulas: Formula[] = [];

  constructor() {
    // why the cast: the server types every function name as a string, while the frontend has been
    // written against the `FormulaName` it knows. Reconciling a hard-coded union with a
    // server-owned list is the expression-language consolidation's job (master plan, phase 4).
    this.formulas$.subscribe((formulas) => (this.formulas = formulas as Formula[]));
  }

  getFormula(formulaName?: string): Formula | undefined {
    return this.formulas.find((formula) => formula.name === formulaName);
  }
}
